import { 
    CATEGORY_BEGIN,
    CATEGORY_ADD,
    CATEGORY_FAILURE,
} from 'app/actions/CategoryActions';

const initialState = {
	byId: {},
	allIds: [],
	isLoading: false,
};

export default function CategoryReducer (state = initialState, action) {
	switch (action.type) {
        case CATEGORY_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case CATEGORY_ADD: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
        case CATEGORY_FAILURE: 
			return {
				...state,
				isLoading: false
			}
		default:
			return state;
	}
};

export const getCategory = state => {
	return state.allIds.map( id => state.byId[id] );
}